import { useQuery } from "@tanstack/react-query";
import { ksFacturesQK } from "../lib/query-keys";
import { findAllFactures } from "../lib/queries/factures-queries";
import Title from "../components/ui/Title";
import { Alert } from "../components/ui/alert";
import Box from "../components/ui/Box";
import { Skeleton } from "../components/ui/skeleton";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import FactureRowItem from "../components/factures/FactureRowItem";

const FacturesPage = () => {
  const { data: factures, isError } = useQuery({
    queryKey: [ksFacturesQK],
    queryFn: findAllFactures,
  });

  return (
    <div>
      <Title className="mb-7">Factures</Title>
      <Box>
        {/* Erreur */}
        {isError && (
          <Alert variant={"destructive"}>
            Une erreur s'est produite au chargement des factures
          </Alert>
        )}

        {/* Chargement */}
        {!isError && !factures && (
          <div className="flex flex-col gap-3">
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
            <Skeleton className="w-full h-9" />
          </div>
        )}

        {/* Vide */}
        {!isError && !!factures && factures.length === 0 && (
          <div className="text-gray-500">Pas de factures à afficher</div>
        )}

        {/* Data */}
        {!isError && !!factures && factures.length > 0 && (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[170px]">Date</TableHead>
                <TableHead className="min-w-[200px]">Description</TableHead>
                <TableHead>Montant</TableHead>
                <TableHead className="text-right">Télécharger</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {factures.map((fac) => (
                <FactureRowItem key={fac.id} facture={fac} />
              ))}
            </TableBody>
          </Table>
        )}
      </Box>
    </div>
  );
};

export default FacturesPage;
